import React, { useEffect, useMemo, useState } from "react";
import styles from "./style.module.css";
import HeaderComponent from "../Header/HeaderComponent";
import MyTotalLoan from "./_components/MyTotalLoan/MyTotalLoan";
import Tabs from "../../components/tabs/Tabs.jsx";
import CurrentLoans from "./_components/CurrentLoans/CurrentLoans";
import { useUser } from "../../hooks/useUser.js";
import { useSearchInstallment } from "../../hooks/fetch-data/useSearchInstallment.js";
import { filterLoanHistoryList, getLoanSummary } from "../../utils/loan.js";
import LoanHistory from "./_components/LoanHistory/LoanHistory";
import BottomBar from "../../components/ui/BottomBar/BottomBar.jsx";
import { useIsDesktop } from "../../hooks/useIsDesktop.js";
import { useTranslation } from "react-i18next";

const MyLoanPage = () => {
  const { userData } = useUser();
  const { t, i18n } = useTranslation("myLoan");
  const { data: userLoanInfo } = useSearchInstallment(userData?.id);

  const loans = userLoanInfo?.loan_data;

  const loanSummary = getLoanSummary(loans);

  const {
    totalLoanAmount,
    totalPaidPrincipal,
    totalPaidInterest,
    totalDebtAmount,
  } = loanSummary;

  const tabs = useMemo(() => {
    if (!userData) return [];

    return [
      {
        title: t("presentLoan"),
        content: <CurrentLoans loans={loans} />,
      },
      {
        title: t("historyLoan"),
        content: <LoanHistory loans={loans} />,
      },
    ];
  }, [userData, loans, t]);

  useEffect(() => {
    if (tabs.length > 0) {
      setCurrentTab(tabs[0]);
    }
  }, [tabs]);

  const [currentTab, setCurrentTab] = useState(null);
  const isDesktop = useIsDesktop();
  useEffect(() => {
    if (tabs.length > 0) {
      setCurrentTab(tabs[0]);
    }
  }, [tabs]);

  return (
    <div>
      <HeaderComponent title="" />
      <div className={styles.container}>
        <MyTotalLoan
          totalLoanAmount={totalLoanAmount}
          totalPaidPrincipal={totalPaidPrincipal}
          totalPaidInterest={totalPaidInterest}
          totalDebtAmount={totalDebtAmount}
        />
        {tabs.length > 0 && currentTab && (
          <Tabs tabs={tabs} currentTab={currentTab} tabSetter={setCurrentTab} />
        )}

        {!isDesktop && <BottomBar />}
      </div>
    </div>
  );
};

export default MyLoanPage;
